module.exports = __webpack_public_path__ + "img/daytime_study1.986eebef.png";